import React from 'react';
import './PatientKanbanView.css'; // Ensure you have the CSS file for styling
import AccessControl from '../AccessControl';

const KanbanView = ({ patients, onRowClick }) => {
    return (
        <AccessControl>
            <div className="patient-kanban-container">
                {patients.map(patient => (
                    <div
                        key={patient._id}
                        className="patient-kanban-card"
                        onClick={() => onRowClick(patient)}
                    >
                        <div className="patient-kanban-content">
                            {/* Add the image tag here */}
                            <div className="flex-div">
                                <div className="patient-kanban-image">
                                    <img
                                        src={patient.imageUrl || '/default-avatar.png'} // Fallback to a default image
                                        alt={`${patient.name}'s avatar`}
                                        className="patient-image"
                                    />
                                </div>
                                <div>
                                    <h3>{patient.name}</h3>
                                    <p>Sex: {patient.sex}</p>
                                    <p>Age: {patient.ageYear}</p>
                                    <p>Date Created: {new Date(patient.createdAt).toLocaleDateString()}</p>
                                    <p>Date Updated: {new Date(patient.updatedAt).toLocaleDateString()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </AccessControl>
    );
};

export default KanbanView;
